import { OverflowTooltip } from '@components/OverflowTooltip';
import maskPhoneNumber from '@lib/utils/maskPhoneNumber';
import { Chip, Text } from '@servicetitan/anvil2';
import strings from '../strings';
import styles from './OutboundCallerIdConfirmationHeader.module.css';
import classNames from 'classnames';

export const OutboundCallerIdConfirmationHeader = ({
  customerName,
  customerNumber,
  memo,
  className,
}: {
  customerName?: string;
  customerNumber: string;
  memo?: string;
  className?: string;
}) => {
  const customerDisplayPhone = maskPhoneNumber(customerNumber);

  return (
    <div className={classNames(styles.section, className)}>
      <Text variant='headline' size='medium' el='h3'>
        {`${strings.labels.toPrefix} ${customerName ?? ''}`}
      </Text>
      <div className={styles.customerInfo}>
        <Text variant='body' size='medium' className={styles.phone}>
          {customerDisplayPhone}
        </Text>
        {memo && (
          <OverflowTooltip content={memo} className={styles.memoContainer}>
            <Chip label={memo} size='medium' className={styles.memoChip} />
          </OverflowTooltip>
        )}
      </div>
    </div>
  );
};
